import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=3a49ce8d"
import script from "./ButtonCard.vue?vue&type=script&lang=ts"
export * from "./ButtonCard.vue?vue&type=script&lang=ts"
import style0 from "./ButtonCard.vue?vue&type=style&index=0&id=3a49ce8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports